import { Api } from "@/common/api/Api";
import { axiosInstance } from "@/plugins/axios";
import { AxiosInstance, AxiosResponse } from "axios";
import AutocompleteApi from "@/common/api/AutocompleteApi";
import { ModelAutocompleteView } from "@/context/model/model/ModelAutocompleteView";

export class ModelApi extends Api {
  constructor(axios: AxiosInstance) {
    super("model", axios);
  }

  private static _instance: ModelApi;
  public static instance(): ModelApi {
    if (!ModelApi._instance) {
      ModelApi._instance = new ModelApi(axiosInstance);
    }
    return ModelApi._instance;
  }

  public static async findAutocomplete(
    search: string,
    query: string
  ): Promise<Array<ModelAutocompleteView>> {
    const response: AxiosResponse = await AutocompleteApi.findAutocomplete("model", search, query);
    return response.data;
  }
}
